import utils from "../../../utils/utils.js";

export default {
  async fetchSearchedTweetEntities(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetSearchedTweetEntities?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSearchedTweetEntities", responseData.data);
  },
  async fetchSearchFeedAccounts(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetSearchFeedAccounts`,
      "GET",
      null,
      null
    );

    context.commit("setSearchFeedAccounts", response.data);
  },

  async fetchSearchFeedById(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/SearchFeedById?accountId=${payload.accountId}&sourceid=${payload.sourceid}&feedtype=${payload.feedtype}&keywordid=${payload.keywordid}&id=${payload.id}&idtype=${payload.idtype}&nextpage=${payload.nextpage}&since=${payload.since}`,
      "GET",
      null,
      null
    );
    context.commit("setSearchFeed", response.data);
  },

  async postSearchedFeedEntity(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateSearchedFeedEntity`,
      "POST",
      null,
      payload
    );
  },
};
